import { render, staticRenderFns } from "./AnimalLi.vue?vue&type=template&id=ae324e54&scoped=true"
import script from "./AnimalLi.vue?vue&type=script&lang=js"
export * from "./AnimalLi.vue?vue&type=script&lang=js"
import style0 from "./AnimalLi.vue?vue&type=style&index=0&id=ae324e54&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae324e54",
  null
  
)

export default component.exports